export const cvContainerId = 'cv-container';
